/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

type IProps = {
    name: string;
    dist?: {
        scriptUrl: string;
        styleUrl: string;
    };
    iframe?: {
        src: string;
    }
    lifecycle?: {
        onLoad(): void;
        onError(error: any): void;
        onMessageReceive?(name: string, payload: any): void;
    };
    element: {
        id: string;
        className?: string;
        style?: React.CSSProperties;
    },
}

type IState = {
    isReady: boolean;
    opened: boolean;
    height: number;
    width: number;
}

export interface IWidgetLoader {
    postMessage: (name: string, payload?: any) => void;
}

export class WidgetLoader 
    extends React.Component<IProps, IState> 
    implements IWidgetLoader {

    private wellKnownMessageNames =  {
        error: this.props.name + '.Error',
        accessToken: this.props.name + '.AccessToken',
        locationId: this.props.name + '.LocationId',
        customerId: this.props.name + '.CustomerId'
    }

    constructor(props: IProps) {
        super(props);
        this.validateParams();
        window.addEventListener('message', this.postMessageListener, {});

        if(props.dist) {
            this.renderStyleTag();
            this.renderScriptTag();
        }
    }

    public postMessage (name: string, payload?: any) {
        if(this.props.dist) {
            window.postMessage({ name: name, ...payload }, "*");
        } else {
            const iframe = document.getElementById(this.props.element.id) as HTMLIFrameElement;
            iframe?.contentWindow?.postMessage({ name: name, ...payload }, "*");
        }
    }

    private validateParams = () => {
        if(this.props.dist && this.props.iframe) {
            throw new Error("Invalid Configuration: dist and iframe params are not allowed together.");
        }
    }

    private renderStyleTag = () => {
        const head = document.querySelector('head');
        const link = document.createElement('link');

        if(this.props.dist) {
            link.href = this.props.dist.styleUrl;
            link.rel = 'stylesheet';
            head && head.appendChild(link);
        }
    };

    private renderScriptTag = () => {
        const head = document.querySelector('head');
        const script = document.createElement('script');

        if(this.props.dist) {
            script.src = this.props.dist.scriptUrl;
            script.type = 'text/javascript';
            script.addEventListener('load', () => {
                if(this.props?.lifecycle?.onLoad) {
                    this.props.lifecycle.onLoad();
                }
            })
            head && head.appendChild(script);
        }
    };

    private postMessageListener = (msg: MessageEvent) => {
        if( msg.data && msg.data.name) {
            switch (msg.data.name) {
                case `${this.props.name}.Load`:
                    this.props.lifecycle && this.props.lifecycle.onLoad();
                    break;
                case this.wellKnownMessageNames.error:
                    this.props.lifecycle && this.props.lifecycle.onError({ ...msg.data });
                    break;
                default:
                    this.props.lifecycle?.onMessageReceive && this.props.lifecycle.onMessageReceive(msg.data.name, { ...msg.data });
            }
        }
    };

    private inlineElement = () => {
        return <div id={this.props.element.id}
            className={this.props.element.className}
            style={this.props.element.style}>
        </div>
    };

    private iframeElement = () => {
        return <iframe
            id={this.props.element.id}
            src={this.props.iframe?.src}
            title={this.props.name}
            className={this.props.element.className}
            style={this.props.element.style}
            />
    };

    render() {
        return (<>
            { this.props.dist && this.inlineElement() }
            { this.props.iframe && this.iframeElement() }
        </>);
    }
}
